import React, { useState } from "react";
import heroImage from "../assets/Landing Page Image 1.png";

interface Props {
  referralData: {
    customer_name: string;
    sales_partner_name: string;
    is_sales_person_list?: boolean;
    sales_persons?: {
      id: string;
      name: string;
    }[];
  } | null;
  hasReferral: boolean;
  loading: boolean;
  referralCode?: string; // 👈 add this
}



const ReferralForm: React.FC<Props> = ({
  referralData,
  hasReferral,
  loading,
  referralCode,
}) => {
  const customerName = referralData?.customer_name || "";
  const salesPartnerName = referralData?.sales_partner_name || "";
  const isSalesPersonList = referralData?.is_sales_person_list || false;
  const salesPersons = referralData?.sales_persons || [];
  const submittedFromDomain = window.location.origin; // example: https://sandbox.sg.tinyassets.com
  const submittedFromUrl = window.location.href;       // example: https://sandbox.sg.tinyassets.com/TA-82-22E4

  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    phone: "",
    sales_person: "",
  });

  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errors, setErrors] = useState({
    full_name: "",
    email: "",
    phone: "",
    sales_person: "",
  });

  // ✅ handle input change
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    // ✅ remove error on typing
    setErrors({
      ...errors,
      [name]: "",
    });
  };

  // ✅ submit form
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const fullName = formData.full_name.trim();
    const email = formData.email.trim();
    const phone = formData.phone.trim();
    const sales_person = formData.sales_person.trim();

    let newErrors: any = {};

    // Full Name
    if (!fullName) {
      newErrors.full_name = "Full Name is required.";
    } else if (fullName.length < 3) {
      newErrors.full_name = "Minimum 3 characters required.";
    }

    // Email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email) {
      newErrors.email = "Email is required.";
    } else if (!emailRegex.test(email)) {
      newErrors.email = "Invalid email format.";
    }

    // Phone
    const phoneRegex = /^[0-9+\-\s]{7,15}$/;
    if (!phone) {
      newErrors.phone = "Phone number is required.";
    } else if (!phoneRegex.test(phone)) {
      newErrors.phone = "Invalid phone number.";
    }

    

    // ❌ Stop if errors
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      setSubmitting(true);

      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}/portals/referral/submit`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            full_name: fullName,
            email: email,
            phone: phone,
            referral_code: referralCode || null,
            sales_person:sales_person,
            submitted_from_domain: submittedFromDomain,
            submitted_from_url: submittedFromUrl,
          }),
        }
      );

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message || "Something went wrong");
      }

      setSuccess(true);
      setFormData({ full_name: "", email: "", phone: "", sales_person: "" });
    } catch (err: any) {
      console.error(err);
    } finally {
      setSubmitting(false);
    }
  };
  return (
    <section className="hero-section">
      <img src={heroImage} alt="Tiny Home" className="hero-bg" />

      <div className="hero-content hero-form">
        <h1>
          {loading ? (
            "Loading..."
          ) : customerName && salesPartnerName ? (
            <>
              You've Been Referred by <br />
              <span>{customerName}</span>
            </>
          ) : (
            <>
              Be the First to Access <br /> Our latest Tiny House Opportunities
            </>

          )}
        </h1>

        <p className="hero-subtext">
          At BigTiny, we curate experiential stays that empower individuals to
          reconnect with what matters.
        </p>

        <div className="form-card">
          <h3>Kick Start Your Passive Income Journey Today</h3>

          <p className="form-desc">
            {hasReferral && customerName && salesPartnerName ? (
              `Book an appointment with ${salesPartnerName} to learn more about this exclusive opportunity.`
            ) : customerName && !salesPartnerName ? (
              `Book an appointment with ${customerName} to learn more about this exclusive opportunity.`
            ) : (
              "Book an appointment with our Sales Partner to learn more about this exclusive opportunity."
            )}
          </p>

          {/* ✅ SUCCESS MESSAGE */}
          {success ? (
            <div className="success-msg">
              ✅ Thank you! Our team will contact you soon.
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <label>Full Name *</label>
              <input
                type="text"
                name="full_name"
                value={formData.full_name}
                onChange={handleChange}
                placeholder="John Doe"
              />
              {errors.full_name && <p className="input-error">{errors.full_name}</p>}
              <label>Email Address *</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="john@example.com"
              />
              {errors.email && <p className="input-error">{errors.email}</p>}
              <label>Phone Number *</label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="+65 1234 5678"
              />
              {errors.phone && <p className="input-error">{errors.phone}</p>}

              {isSalesPersonList && (
                <>
                  <label>Select Sales Partner *</label>

                  <select
                    name="sales_person"
                    value={formData.sales_person}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        sales_person: e.target.value,
                      })
                    }
                  >
                    <option value="">Any Sales Partner</option>

                    {salesPersons.map((person) => (
                      <option key={person.id} value={person.id}>
                        {person.name}
                      </option>
                    ))}
                  </select>

                  {errors.sales_person && (
                    <p className="input-error">{errors.sales_person}</p>
                  )}
                </>
              )}

              <small className="form-note">
                By submitting your details, you consent to Tiny Assets Pte Ltd (Big Tiny) collecting and using your data under the PDPA
              </small>

              <button type="submit" disabled={submitting}>
                {submitting ? "Submitting..." : "Submit"}
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
};

export default ReferralForm;